var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mv-container",style:({
    background: _vm.finalBg
  })},[_vm._t("left"),_c('div',{staticClass:"mv-container__content",style:(_vm.contentStyle)},[(_vm.header)?_c('div',{staticClass:"mv-container__header"},[_c('div',{staticClass:"mv-container__title",style:({
          color: _vm.titleColor
        })},[_vm._v(_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"mv-container__desc",style:({
          color: _vm.descriptionColor
        })},[_vm._v(_vm._s(_vm.description)+" ")])]):_vm._e(),_vm._t("default")],2),_vm._t("right")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }